// @flow

import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import type { SplitClient } from '@splitsoftware/splitio';

import { useCurrentUser } from 'hooks/useCurrentUser';
import { splitIoState } from './state';
import { getFactory } from './factory';

export const useSplitClient = (): [SplitClient | null, boolean, boolean] => {
  const [state, setState] = useRecoilState(splitIoState);
  const { data } = useCurrentUser();
  const email = data?.me.email;

  useEffect(() => {
    setState((state) => {
      if (email == null || email === state.email) {
        return state;
      }
      const factory = getFactory(email);
      if (factory == null) {
        return state;
      }
      if (state.client != null) {
        state.client.destroy();
      }
      const client = factory.client(email);
      client.once(client.Event.SDK_READY, () => {
        setState((state) => ({ ...state, ready: true, timeout: false }));
      });
      client.once(client.Event.SDK_READY_TIMED_OUT, () => {
        setState((state) => ({ ...state, ready: false, timeout: true }));
      });

      return { ...state, client, email };
    });
  }, [email, setState]);

  return [state.client, state.ready, state.timeout];
};
